export enum Constants {
  headerHeight = "3.5rem",
  sidePanelWidth = "16.5rem",
  bottomNavbarHeight = "3.5rem",
}
